export default "__VITE_ASSET__B2rIzp6x__"